import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

const SidebarItem = styled(Box)`
  padding: ${themeGet('space.4')};
  border-radius: ${themeGet('radii.default')};

  ${mediaQuery.minWidth.md} {
    padding: 0;
    border-radius: 0;
    border-bottom: 1px solid ${themeGet('colors.greys.alto')};
    margin-bottom: ${themeGet('space.4')};
  }

  &:last-of-type {
    border-bottom: 0;
  }
`;

export default SidebarItem;
